export default __webpack_public_path__ + "static/media/sanmar21.cc4ba2dd.jpg";